export class createProfileConstants {
    static readonly CREATE_PROFILE_USER = '/profile/users/';
    static readonly PROFILE_ACTION ='/profiles';
    static readonly USERS ='/users/';
    static readonly SLASH ='/';
    static readonly PROFILE = '/profile';
    static readonly PUBPROFILE = '/pubprofile';
    static readonly RETAILERS = '/retailers/';
    static readonly STANDARD = '/standard';
    static readonly PACKAGE = '/package';
    static readonly PACKAGE_HANDLER = '/packagehandler';
    static readonly STANDARD_PACKAGE = '/standardpackage';
    static readonly PRODUCT_MAP = '/productmap';
    static readonly IPOS = 'Ipos';
    static readonly IPOS_FOR_DEB = 'ipos_2.0_amd64';
    static readonly DEB = '.deb';
    static readonly SELECTED_PACKAGE = '&standardPackage';
    static readonly PACKAGE_TYPE = '&packageType';
    static readonly EQUALS = '=';
    static readonly SELECTED_LANGUAGE = '?locale';
    static readonly OPERATING_SYSTEM = '/operatingsystem';

}